module.exports = __webpack_public_path__ + "fonts/font.3c96f62.woff2";